import type { SVGProps } from "react";
export default function SvgHeading(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M6 12h12" />
			<path d="M6 20V4" />
			<path d="M18 20V4" />
		</svg>
	);
}
